/**
 * kundenpreisEdits — reine Funktionen für die Bearbeitung BESTEHENDER
 * Kundenpreise im Produkt-Editor (Admin).
 *
 * Es werden ausschließlich vorhandene customer_prices-Zeilen geändert:
 * kein Anlegen, kein Löschen. Eingaben sind Rohstrings ({ [id]: '8,50' }),
 * damit laufende Eingaben nicht verfälscht werden; erst beim Diff wird
 * geparst (deutsches Komma erlaubt) und auf 2 Nachkommastellen gerundet.
 */
import { parseDecimal } from './productEditorModel';

/** Angezeigter Preis einer Kundenpreis-Zeile: custom_price, sonst preis, sonst null */
export function kundenpreisValue(cp) {
  if (!cp) return null;
  if (cp.custom_price !== null && cp.custom_price !== undefined) return Number(cp.custom_price);
  if (cp.preis !== null && cp.preis !== undefined) return Number(cp.preis);
  return null;
}

const round2 = (n) => Math.round(n * 100) / 100;

/**
 * Vergleicht Eingaben mit den geladenen Kundenpreisen.
 * @param {Array} kundenpreise  geladene customer_prices-Zeilen
 * @param {Object} edits        { [id]: rohe Eingabe }
 * @returns {{ changes: Array<{id, lead_id, lead_name, alt, neu}>, errors: Array<{id, lead_name, meldung}> }}
 */
export function diffKundenpreisEdits(kundenpreise, edits) {
  const changes = [];
  const errors = [];
  const byId = new Map((kundenpreise || []).map((cp) => [cp.id, cp]));
  for (const [id, raw] of Object.entries(edits || {})) {
    const cp = byId.get(id);
    if (!cp) continue; // Eingabe zu einer Zeile, die es (nicht mehr) gibt → ignorieren
    const neu = parseDecimal(raw);
    if (neu === null || Number.isNaN(neu) || neu < 0) {
      errors.push({ id, lead_name: cp.lead_name || '', meldung: `Ungültiger Kundenpreis für ${cp.lead_name || 'Kunde'}` });
      continue;
    }
    const alt = kundenpreisValue(cp);
    const gerundet = round2(neu);
    if (alt !== null && round2(alt) === gerundet) continue;
    changes.push({ id, lead_id: cp.lead_id, lead_name: cp.lead_name || '', alt, neu: gerundet });
  }
  return { changes, errors };
}

/** true, wenn es ungespeicherte Änderungen oder fehlerhafte Eingaben gibt */
export function hasKundenpreisEdits(kundenpreise, edits) {
  const { changes, errors } = diffKundenpreisEdits(kundenpreise, edits);
  return changes.length > 0 || errors.length > 0;
}
